class KoketaFaq extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.items = [...this.querySelectorAll('[data-koketa-faq-item]')];

    this.items.forEach((item) => {
      const summary = item.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleItem(item);
      });
    });
  }

  toggleItem(item) {
    if (item.dataset.animating === 'true') return;
    if (item.open) {
      this.collapse(item);
      return;
    }

    this.items.filter((other) => other !== item && other.open).forEach((other) => this.collapse(other));
    this.expand(item);
  }

  expand(item) {
    const summary = item.querySelector('summary');
    if (!summary) return;
    if (this.reducedMotion.matches || !item.animate) {
      item.open = true;
      return;
    }

    item.dataset.animating = 'true';
    const startHeight = `${summary.offsetHeight}px`;
    item.open = true;
    const endHeight = `${item.offsetHeight}px`;
    item.style.overflow = 'hidden';

    const animation = item.animate(
      { height: [startHeight, endHeight], opacity: [.82, 1] },
      { duration: 340, easing: 'cubic-bezier(.2,.75,.2,1)' }
    );
    animation.onfinish = () => this.finish(item);
    animation.oncancel = () => this.finish(item);
  }

  collapse(item) {
    const summary = item.querySelector('summary');
    if (!summary) return;
    if (this.reducedMotion.matches || !item.animate) {
      item.open = false;
      return;
    }

    item.dataset.animating = 'true';
    item.style.overflow = 'hidden';
    const animation = item.animate(
      { height: [`${item.offsetHeight}px`, `${summary.offsetHeight}px`], opacity: [1, .82] },
      { duration: 260, easing: 'cubic-bezier(.4,0,.2,1)' }
    );
    animation.onfinish = () => {
      item.open = false;
      this.finish(item);
    };
    animation.oncancel = () => this.finish(item);
  }

  finish(item) {
    item.style.removeProperty('overflow');
    delete item.dataset.animating;
  }
}

if (!customElements.get('koketa-faq')) customElements.define('koketa-faq', KoketaFaq);
